import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { INVOICES_ME_API } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import { fetching, FetchingEnum } from "./Fetching";

export const initialStateHistoryPayment = {
  fetchingHistoryPayment: FetchingEnum.DONE,
  fetchingHistoryPaymentMore: FetchingEnum.DONE,
};

const taggedDocument = types.model("taggedDocument", {
  accountingDocumentNumber: types.string,
  amount: types.number,
});

const HistoryData = types.model({
  type: types.string,
  accountingDocumentId: types.number,
  accountingDocumentNumber: types.maybeNull(types.string),
  documentDate: types.string,
  originalAmount: types.number,
  remainingAmount: types.number,
  pdfUrl: types.maybeNull(types.string),
  open: types.boolean,
  description: types.maybeNull(types.string),
  label: types.maybeNull(types.string),
  taggedCreditNotes: types.maybeNull(types.array(taggedDocument)),
});

export const HistoryPayment = types
  .model({
    fetchingHistoryPayment: fetching,
    historyPaymentData: types.optional(types.array(HistoryData), []),
    statusHistoryPayment: types.maybeNull(types.number),
    fetchingHistoryPaymentMore: fetching,
  })
  .actions((self) => ({
    initialStateHistoryPayment: () => {
      self.fetchingHistoryPayment = FetchingEnum.DONE;
      self.historyPaymentData.replace([]);
      self.statusHistoryPayment = null;
      self.fetchingHistoryPaymentMore = FetchingEnum.DONE;
    },
    getHistoryPayment: flow(function* (token: string, NextLink?: string) {
      if (NextLink) {
        self.fetchingHistoryPaymentMore = "pending";
      } else {
        self.fetchingHistoryPayment = FetchingEnum.PENDING;
        self.historyPaymentData.replace([]);
        self.statusHistoryPayment = null;
      }
      try {
        const result = yield axios.get(INVOICES_ME_API, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            Filter: JSON.stringify({ Open: false, NextLink: NextLink }),
          },
        });
        // if (NextLink && self.historyPaymentData && result.data) {
        //   console.log(self.historyPaymentData);
        //   const temp: any = self.historyPaymentData?.values || [];
        //   self.historyPaymentData.nextLink = result.data.nextLink;
        //   self.historyPaymentData.values = temp.concat(result.data.values);
        // } else {
        self.historyPaymentData.replace(result.data);
        // }
        self.fetchingHistoryPayment = "done";
        self.statusHistoryPayment = result.status;
        self.fetchingHistoryPaymentMore = "done";
      } catch (error) {
        self.fetchingHistoryPayment = "error";
        self.fetchingHistoryPaymentMore = "error";
        AlertResultApi(error, error.response?.data?.message);
        self.statusHistoryPayment = error.response?.status;
      }
    }),
  }));

export type HistoryPaymentType = Instance<typeof HistoryPayment>;
export type HistoryPaymentDataType = Instance<typeof HistoryData>;
